import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/core/each/each.js";
import "dabbyjs/src/core/get/get.js";
import "dabbyjs/src/attributes/attr/attr.js";
import "dabbyjs/src/attributes/class/class.js";
import "dabbyjs/src/attributes/css/css.js";
import "dabbyjs/src/attributes/data/data.js";
import "dabbyjs/src/attributes/prop/prop.js";
import "dabbyjs/src/dimensions/offset/offset.js";
import "dabbyjs/src/dimensions/scroll/scroll.js";
import "dabbyjs/src/dimensions/width-height/width-height.js";
import "dabbyjs/src/events/on/on.js";
import "dabbyjs/src/events/trigger/trigger.js";
import "dabbyjs/src/traversal/closest/closest.js";
import "dabbyjs/src/traversal/eq/eq.js";
import "dabbyjs/src/traversal/filter/filter.js";
import "dabbyjs/src/traversal/index/index.js";
import "dabbyjs/src/traversal/parents/parents.js";
import "dabbyjs/src/traversal/siblings/siblings.js";

// filter the selector by just the visible ones
const filter = function () {
	let obj = this;
	while (obj !== document) {
		if (!obj || !obj.parentNode) {
			return false;
		} else {
			const style = getComputedStyle(obj);
			if (style.display === "none" || style.visibility === "hidden" || !style.opacity || (!parseInt(style.height) && style.overflow === "hidden")) {
				return false;
			}
		}
		obj = obj.parentNode;
	}
	return true;
};

export default (obj) => {
	if (obj.length) {
		// filterHelp();
		let show = false,
			lastindex = -1;
		const first = obj.get(0).classList.item(0),
			nodot = first + (first.indexOf("__") > -1 ? "-" : "__"),
			cls = "." + nodot,
			doc = $(document),
			preferences = $(cls + "content-setting-switch"),
			radio = $(cls + "wrap-switch", obj).each(function () {
				const $this = $(this),
					item = $("[data-selector]", $this.parent()),
					selector = $(item.data("selector")),
					trigger = item.data("trigger"),
					close = $(cls + "switch-close").on("change", () => {
						if (close.prop("checked")) {
							lastindex = -1;
						}
					}),

					// see if the target is on page and add describedby attribute
					obj = selector.filter(filter).attr("aria-describedby", $(cls + "content-desc", item).attr("id")),
					isWide = obj.innerWidth() > 400; // square highlight if wider than 400px

				// indicate there are items
				if (obj.length) {
					show = true;
				}

				// only show visible items
				$this.on("change", function () {
					const obj = selector.filter(filter), // check if it is now visible
						index = radio.index($this);
					if (obj.length) {

						// position circle
						let circle = $(cls + "circle", item),
							content = $(cls + "content", item),
							top = parseFloat(circle.css("paddingTop")),
							left = parseFloat(circle.css("paddingLeft")),
							width = obj.innerWidth(),
							height = obj.innerHeight(),
							pos = obj.offset(),
							max = Math.max(width, height),
							offset = {
								top: isWide ? pos.top : pos.top + (height / 2) - (max / 2) - top,
								left: isWide ? pos.left : pos.left + (width / 2) - (max / 2) - left
							},
							circleWidth = isWide ? width : max,
							circleHeight = isWide ? Math.min(height, 400) : max,
							docWidth = doc.width(),
							docHeight = doc.height(),
							contentWidth = content.width(),
							contentHeight = content.height(),
							offsetTop, scrollTop;

						// if wide make the circle flat
						if (isWide) {
							circle.addClass(nodot + "circle--flat");
						}

						// move item to the correct location and set circle border and position
						circle
							.width(circleWidth)
							.height(circleHeight)
							.offset({
								top: Math.min(offset.top, 0),
								left: Math.min(offset.left, 0)
							})
							.css({
								borderTopWidth: Math.max(offset.top, 0),
								borderLeftWidth: Math.max(offset.left, 0),
								borderRightWidth: docWidth - offset.left - circleWidth,
								borderBottomWidth: docHeight - offset.top - circleHeight
							});

						// calculate content box position and scroll position
						if (offset.top + circleHeight + contentHeight < docHeight) {
							offsetTop = offset.top + circleHeight + (top * 2) + 10;
							scrollTop = offset.top;
						} else {
							offsetTop = offset.top - contentHeight - (top * 2) - 10;
							scrollTop = offsetTop;
							content.addClass(nodot + "content--top");
						}

						// position content
						content.offset({
							top: offsetTop,
							left: Math.max(Math.min(offset.left + (circleWidth / 2) - (contentWidth / 2), docWidth - contentWidth), 0)
						});

						// scroll to the current item
						window.scrollTo({
							top: scrollTop,
							behavior: "smooth"
						});

					// show the next item
					} else {
						const next = index + (lastindex < index ? 1 : -1);
						if (next === radio.length || next === -1) {
							close.prop("checked", true).trigger("change");
						} else {
							lastindex = index;
							radio.eq(next).prop("checked", true).trigger("change");
						}
					}
				});

				// trigger item on when another item is changed
				if (trigger) {
					$(trigger).on("change", () => {
						setTimeout(() => { // wait for animation
							if (preferences.prop("checked") && selector.filter(filter).length) {
								$this.prop("checked", true).trigger("change");
							}
						}, 1000);
					});
				}
			});

		// if there are items to show
		if (show) {

			// update preferences
			preferences.on("change", function () {
				const $this = $(this),
					setting = $this.prop("checked"),
					form = $(this).closest("form");
	
				fetch(form.attr("action") || "", {
					method: form.attr("method"),
					headers: {accept: "application/json"},
					body: new FormData(form.get(0))
				}).then(() => {
					preferences.prop("checked", setting);
				});
			});

			// auto show help
			if (preferences.prop("checked")) {
				setTimeout(() => {
					radio.eq(0).prop("checked", true).trigger("change");
				}, 1000);
			}

			// hide on resize
			$(window).on("resize", () => {
				$(cls + "switch-close").prop("checked", true);
			});

		// hide help button if no items are on page
		} else {
			$(cls + "label").css("display", "none");
		}
	}
};
